import { Star, Quote } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { useContent } from "../../context/ContentContext";

export const Testimonials = () => {
  const { testimonials } = useContent();
  return (
    <section className="bg-white py-24" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading center eyebrow={testimonials.eyebrow} title={testimonials.title} />
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {testimonials.items.map((t, i) => (
            <Reveal key={t.name || i} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-${i}`}
                className="flex h-full flex-col rounded-2xl border border-gray-200 bg-white p-8 shadow-sm transition-shadow hover:shadow-lg"
              >
                <Quote className="h-8 w-8 text-gold/40" />
                <div className="mt-3 flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} size={16} className="fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-base leading-relaxed text-navy">“{t.text}”</blockquote>
                <figcaption className="mt-6 border-t border-gray-100 pt-4">
                  <p className="font-display font-bold text-navy">{t.name}</p>
                  <p className="text-xs text-muted-foreground">{t.location}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
